.product-trials-banner {
  overflow: hidden;
  display: flex;
  border-radius: 4px;
  border: 1px solid;
  border-color: var(--chart-103-pressed);
  background-color: var(--white-layout-302-level-1-elevation);

  .header-title {
    font-weight: 500;
    line-height: 33px;
    color: var(--body-text-arrows-400);
  }

  .image-container {
    width: 50%;
    position: relative;

    img {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .data-container {
    width: 50%;
    padding: calc(var(--spacer) * 4) calc(var(--spacer) * 4.5) calc(var(--spacer) * 2) calc(var(--spacer) * 6);
  }
}
